<template>
    <x-page title="Metric Record">
        <template #header-actions>
            <x-create-button
                url="/admin/metric-records/create"
                :disabled="isLoading"
                v-if="can('createMetricRecords')"
            />
        </template>

        <x-filter-box :onFilter="handleFilter" :onReset="resetFilter">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Dari Tanggal">
                        <input
                            class="form-control"
                            type="date"
                            v-model="filters.date_start"
                            @keyup.enter="() => handleFilter()"
                        />
                    </x-form-group>
                </div>
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Sampai Tanggal">
                        <input
                            class="form-control"
                            type="date"
                            v-model="filters.date_end"
                            @keyup.enter="() => handleFilter()"
                        />
                    </x-form-group>
                </div>
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Judul">
                        <input
                            class="form-control"
                            type="text"
                            v-model="filters.search"
                            @keyup.enter="() => handleFilter()"
                            placeholder="Masukkan judul"
                        />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table
            :headers="['#', 'Tanggal', 'Judul', '']"
            :is-loading="isLoading"
        >
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link
                        :to="`/admin/metric-records/${resource.id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ resource.date | date }}
                    </router-link>
                    <div v-if="resource.is_anomaly" title="Record ini akan di-exclude dari report">
                        <x-label color="warning">
                            <i class="fa fa-exclamation-triangle" /> Anomali
                        </x-label>
                    </div>
                </td>
                <td>
                    {{ resource.name }}
                </td>
                <td>
                    <x-quick-edit-button
                        :url="`/admin/metric-records/${resource.id}/edit`"
                        :disabled="isLoading"
                        v-if="can('updateMetricRecords')"
                    />
                    <x-quick-delete-button
                        @click="deleteResource(resource)"
                        :disabled="isLoading"
                        v-if="can('deleteMetricRecords')"
                    />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
    </x-page>
</template>

<script>
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XCreateButton from "../../components/XCreateButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import { deletePrompt, handleGeneralXhrError } from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import XLabel from "../../components/XLabel.vue";
import XPagination from '../../components/XPagination.vue';

const defaultFilters = {
    date_start: null,
    date_end: null,
    search: null,
};

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XLabel,
        XPagination,
    },
    created() {
        this.preselectFilters(defaultFilters);
        this.handleFilter().catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
        };
    },
    methods: {
        deleteResource(resource) {
            const label = this.$options.filters.date(resource.date);
            deletePrompt({
                name: label,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/metric-records/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: `Berhasil`,
                                text: `${label} dihapus!`,
                            });
                            this.fetchResources();
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/metric-records", {
                    params: {
                        ...route.query,
                        without_global_scopes: 1,
                    },
                })
                .then((response) => {
                    this.resources = response.data.data;
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: this.$route.query.page || 1,
                }),
            });
        },
        resetFilter() {
            this.filters = { ...defaultFilters };
            this.handleFilter();
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
};
</script>